import { useQuery } from 'react-query';

import api from '@root/api';

export default function useApiKey(id) {
  return useQuery(['apiKeys.getById', id], () => api.apiKeys.getById({ id }));
}
